import React from 'react';
import bem from 'utils/bem';
import Icon from 'components/Icon';
import Text from 'components/Text';
import { IconButton } from 'components/Button';
import Model from '../../../model';
import './index.sass';

const { block, el } = bem('address-and-phones');

export const whatsAppContacts = {
    link: 'https://wa.me/79851234432',
    phone: '+7 985 123-44-32'
};

const AddressAndPhones = ({ mod = 'short' }) => {
    const { openOfficeMap } = Model.modal;

    const isFull = mod === 'full';
    const ButtonFooter = (
        <IconButton name={ 'caret-right' } className={ el('scheme') } mod={ 'transparent-gold' } onClick={openOfficeMap}
                    target={ '_blank' }>
            <Text>Схема проезда</Text>
        </IconButton>
    );
    const ButtonsContacts = (
        <div className={el('location-buttons')}>
            <IconButton name={ 'map-trifold' } className={ el('scheme') } mod={ 'transparent-gold' } onClick={openOfficeMap}
                        target={ '_blank' }>
                <Text>Схема проезда</Text>
            </IconButton>
            <IconButton name={ 'play' } className={ el('scheme') } mod={ 'transparent-gold' }
                        to={ 'https://www.youtube.com/watch?v=yzUiHCRsd-s' } target={ '_blank' }>
                <Text>Видео проезда</Text>
            </IconButton>
        </div>
    )

    return (
        <>
            <div className={ el('location') }>
                <Icon name={ 'map-pin' }/>
                <div className={ el('address') }>
                    <a className={ el('address-link' )} target={'_blank'} href={'https://yandex.ru/maps/-/CCUcRSFXDC'}><Text>4-я Тверская-Ямская ул., 22</Text></a>
                    { isFull ? ButtonsContacts : ButtonFooter }
                </div>
            </div>
            <div className={ el('connect') }>
                <a href={ 'mailto:hello@otvet.co' } className={ el('mail') }>
                    <Icon name={ 'envelope' }/>
                    <div className={ el('labeled-text') }>
                        <div className={ el('label') }><Text>По всем вопросам</Text></div>
                        <div className={ el('value') }><Text>hello@otvet.co</Text></div>
                    </div>
                </a>
                <div className={el('whatsapp-block')}>
                    <Icon name={ 'whatsapp-logo' }/>
                    <div className={el('phones')}>
                        <a href={ whatsAppContacts.link } target={'_blank'}>
                            <Text>{ whatsAppContacts.phone }</Text>
                        </a>
                    </div>
                </div>
                <div className={ el('phones-block') }>
                    <Icon name={ 'phone-call' }/>
                    <div className={ el('phones')}>
                        <a href={ 'tel:+79851234432' } className={ el('labeled-text') }>
                            <div className={ el('label') }><Text>Консультации</Text></div>
                            <>
                                <span className={ el('value') }><Text>+7 985 123-44-32</Text></span>
                                { isFull && <span className={el('label')}><Text> 10:00 — 20:00 мск</Text></span> }
                            </>
                        </a>
                        <a href={ 'tel:+79269492759' } className={ el('labeled-text') }>
                            <div className={ el('label') }><Text>Магазин</Text></div>
                            <>
                                <span className={ el('value') }><Text>+7 926 949-27-59</Text></span>
                                { isFull && <span className={el('label')}><Text> 10:00 — 20:00 мск</Text></span> }
                            </>
                        </a>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddressAndPhones;
